<template>
  <section class='common-dialog main-cl'>
    <!-- 背景遮罩层 -->
    <div class='dialog-markAll gray-10-bg' v-if='showFlag'></div>

    <!-- 弹出框 -->
    <transition name='drop'>
      <div class='dialog-frame main-bg' :style="{width: width + 'px'}" v-if='showFlag' ref='dialog'>
        <div class='dialog-frame-head'>
          <span class='dialog-frame-head-text b-1-cl'>{{ titleText }}</span>
          <svg-icon
            iconClass="close"
            className="icon-14 dialog-frame-head-close gray-cl"
            @click='close'></svg-icon>
          <!-- <span class='dialog-frame-head-close'>
            <c-iconButton @click='close'>
              <svg class='icon icon-16' aria-hidden='true'>
                <use xlink:href='#icon-c_7'></use>
              </svg>
            </c-iconButton>
          </span> -->
        </div>

        <!--body-->
        <div class='dialog-frame-body' :style='bodyStyle'>
          <slot />
        </div>

        <!--footer-->
        <div class='dialog-frame-bottom' v-if='haveOption'>
          <div class='dialog-frame-options'>
            <c-button
              v-if="!hideCancel"
              class-name='close-btn'
              defaultColorClass="gray-30-bg white-cl"
              hoverColorClass="gray-60-bg white-cl"
              activeColorClass="gray-60-bg white-cl"
              @click='close'
              >
              {{ closeTextProps }}
            </c-button>
            <c-button
              name='dialogConfirm'
              @click='confirm'
              class-name="confirm-btn"
              :loading='confirmLoading'
              :disabled='confirmDisabled'
              >
              {{ confirmTextProps }}
            </c-button>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'c-dialog',
  props: {
    // 展示变量
    showFlag: { default: false, type: Boolean },
    // 上边距  有警告文字时为20px
    paddingTop: { default: '30px', type: String },
    // 下边距
    paddingBottom: { default: '30px', type: String },
    // 提示文案
    titleText: { default: '', type: String },
    // 确认按钮的文案
    confirmText: { default: '', type: String },
    // 取消按钮的文案
    closeText: { default: '', type: String },
    // 确认按钮的loading
    confirmLoading: { default: false, type: Boolean },
    // 确认按钮的disabled
    confirmDisabled: { default: false, type: Boolean },
    // 是否有下面option区域
    haveOption: { default: true, type: Boolean },
    // 是否隐藏 取消 按钮
    hideCancel: { default: false, type: Boolean },
    // 弹框宽度
    width: { type: Number, default: 460 },
  },
  watch: {
    showFlag(v) {
      if (v) {
        this.$nextTick(() => {
          if (this.$refs.dialog.offsetHeight % 2 !== 0) {
            const str = `${this.$refs.dialog.offsetHeight + 1}px`;
            this.$refs.dialog.style.minHeight = str;
          }
        });
        this.stopScroll();
      } else {
        this.canScroll();
      }
    },
  },
  computed: {
    confirmTextProps() {
      if (this.confirmText.length) {
        return this.confirmText;
      }
      // 确定
      return this.$t('components.dialog.confirmText');
    },
    closeTextProps() {
      if (this.closeText.length) {
        return this.closeText;
      }
      // 取消
      return this.$t('components.dialog.closeText');
    },
    bodyStyle() {
      return {
        paddingTop: this.paddingTop,
        paddingBottom: this.paddingBottom,
      };
    },
  },
  methods: {
    close() {
      this.$emit('close');
      this.canScroll();
    },

    confirm() {
      this.$emit('confirm');
      this.canScroll();
    },

    // 禁止body滚动
    stopScroll() {
      const mo = (e) => { e.preventDefault(); };

      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', mo, false);// 禁止页面滑动
    },

    // 允许body滚动
    canScroll() {
      const mo = (e) => { e.preventDefault(); };

      document.body.style.overflow = '';// 出现滚动条
      document.removeEventListener('touchmove', mo, false);
    },
  },
};
</script>

<style lang='scss' scoped>
.drop-enter-active {
  animation: drop-in .3s;
}

.drop-leave-active {
  animation: drop-in .3s reverse;
}

@keyframes drop-in {
  0% {
    // transform: translateY(-100%);
    top: 35%;
    opacity: 0.7
  }
  100% {
    /* margin-top: 10px; */
    // transform: translateY(-50%);
    opacity: 1;
  }
}

.common-dialog {
  .btnClass {
    margin-right: 10px;
  }

  .dialog-markAll {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 999;
    top: 0;
    left: 0;
  }

  .dialog-frame {
    transform: 0.3s transition;
    position: fixed;
    z-index: 1000;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    // width: 460px;
    border-radius: 6px;
  }

  .dialog-frame-head {
    box-sizing: border-box;
    height: 48px;
    width: 100%;
    padding: 0 24px;
    line-height: 48px;
    border-radius: 6px 6px 0 0;
  }

  .dialog-frame-head-text {
    font-size: 16px;
  }

  .dialog-frame-head-close {
    float: right;
    cursor: pointer;
    // font-size: 20px;
    margin-top: 17px;
  }

  .dialog-frame-body {
    width: 100%;
    padding: 40px 24px;
    box-sizing: border-box;
  }

  .close-btn, .confirm-btn {
    font-size: 16px;
    border-radius: 4px;
    height: 40px;
    line-height: 38px;
    flex: 1;
  }

  .close-btn {
    margin-right: 16px;
  }

  .dialog-frame-bottom {
    // margin-bottom: 40px;
    // height: 40px;
    position: relative;

    .dialog-frame-options {
      padding: 24px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
